export enum ReportTypeEnum {
  Custom,
  DeaReport
}
